/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { Map, Record } from 'immutable';

export interface SalesLedgerState extends Map<string, any> {

  ledgerList: any;
  ledgerListLoading: boolean;
  ledgerListLoaded: boolean;
  ledgerListFailed: boolean;
}

export const SalesLedgerStateRecord = Record({

  ledgerList: [],
  ledgerListLoading: false,
  ledgerListLoaded: false,
  ledgerListFailed: false,
});